import script from "./Index.vue?vue&type=script&setup=true&lang=js"
export * from "./Index.vue?vue&type=script&setup=true&lang=js"

import "./Index.vue?vue&type=style&index=0&id=c86a5eb0&lang=less&scoped=true"
import "./Index.vue?vue&type=style&index=1&id=c86a5eb0&lang=less"

import exportComponent from "/data/web/pay/idpay/idpay-h5/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c86a5eb0"]])

export default __exports__